import { jsx as _jsx } from "react/jsx-runtime";
import { List, ListSubheader } from '@mui/material';
export function IconList(props) {
    const { title, children, dense } = props;
    return (_jsx(List, { dense: dense, subheader: title !== undefined ? (_jsx(ListSubheader, { component: "div", disableSticky: true, children: title })) : undefined, children: children }));
}
//# sourceMappingURL=IconList.js.map